import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { UpdatePaymentTokenRequestDTO } from '@/core/api/dtos/request/payment/updatePaymentToken'
import { PaymentToken } from '@/core/api/entities/paymentToken'
import { PaymentTokenMapper } from '@/core/api/mappers/paymentTokenMapper'
import { paymentService } from '@/core/api/services/paymentService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

export const useUpdatePaymentToken = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseMutationResult<
	PaymentToken,
	Error,
	{ paymentTokenId: number; data: UpdatePaymentTokenRequestDTO },
	any
> => {
	return useMutation({
		mutationFn: ({
			paymentTokenId,
			data,
		}: {
			paymentTokenId: number
			data: UpdatePaymentTokenRequestDTO
		}) =>
			paymentService
				.patchPaymentToken(paymentTokenId, data, config)
				.then(({ data: response }) => {
					return PaymentTokenMapper.toEntity(response.data)
				}),
		...options,
	})
}
